import React from 'react';
import { Button } from "@commonsku/styles";
import { useSelector } from 'react-redux';

const PaymentsPortal = () => {
  const portalUrl = useSelector((state: any) => state.portal_url);

  return (
    <div>
      <Button onClick={() => window.open(portalUrl, '_blank', 'noopener,noreferrer')}>
        Open Payments Portal
      </Button>
    </div>
  );
};

PaymentsPortal.label = 'Payments Portal';

export default PaymentsPortal;
